import React from 'react';
import LeafIcon from '../../../assets/leaf-icon.svg';
import FlowGraphic from '../../../assets/welcoming-slide-3-matters.png';
import AvatarGraphic from '../../../assets/welcoming-slide-3-avatar.png';

export default function Slide3() {
  return (
    <div className="animate-in slide-in-from-right duration-300 -mb-6 mx-0 md:mx-5">
      {/* Heading */}
      <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6 text-center">
        Give{' '}
        <span className="inline-flex items-center gap-1">
          Twigs <img src={LeafIcon} alt="Twig" className="inline w-6 h-6" />
        </span>{' '}
        to content that deserves it
      </h1>

      {/* Daily Allowance Bar */}
      <div
        className="rounded-xl overflow-hidden shadow-sm"
        style={{
          background: 'linear-gradient(128.97deg, #F9F6FE 27.64%, #F4FDF6 99.68%)',
          border: '1px solid #F3E8FF'
        }}
      >
        <div className="bg-growth-green text-white text-sm text-center font-semibold tracking-wide px-4 py-2">
          Daily Allowance
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 divide-y sm:divide-y-0 sm:divide-x divide-[#B4B4B4] text-center mt-5">
          <div className="py-5 flex flex-col justify-start md:justify-center">
            <span className="text-xs uppercase tracking-wide h-10 md:h-7">Daily Twigs</span>
            <span className="text-xl font-bold text-[#204A22] flex flex-col-reverse md:flex-row items-center justify-center">
              20
              <img src={LeafIcon} alt="Twig" className="w-6 h-6 md:mt-0 md:ml-2" />
            </span>
          </div>
          <div className="py-5 flex flex-col">
            <span className="text-xs uppercase tracking-wide justify-start md:justify-center h-10 md:h-7">
              Per post / comment
            </span>
            <span className="text-xl font-semibold text-[#204A22]">
              1-5 <span className="md:inline block">Twigs</span>
            </span>
          </div>
          <div className="py-5 flex flex-col justify-start md:justify-center">
            <span className="text-xs uppercase tracking-wide h-10 md:h-7">Reset time</span>
            <span className="text-xl font-semibold text-[#204A22]">Midnight UTC</span>
          </div>
        </div>
        <div className="px-4 pb-3 md:-mt-1 mt-5 text-center">
          <p className="text-growth-green text-sm">Use them or lose them!</p>
        </div>
      </div>

      {/* Why Twigs Matter Section */}
      <div className="mt-16 relative">
        <div className="flex flex-col md:flex-row gap-5 md:gap-6 items-center md:items-start md:justify-center">
          {/* Flow Diagram & Overlayed Text */}
          <div className="relative w-full md:flex-1 mb-5">
            <h2 className="absolute top-[-10px] left-[calc(22.5%)] md:left-[calc(27.5%)] text-xl md:text-2xl font-semibold text-gray-900 mb-8 text-center">
              Why Twigs Matter
            </h2>
            <img
              src={FlowGraphic}
              alt="Twigs flow diagram"
              className="w-[424px] mx-auto select-none pointer-events-none origin-top"
            />
            <h2 className="absolute md:inline w-40 md:w-full text-sm md:text-base md:text-center mt-5 font-bold">
              <p className="whitespace-normal md:whitespace-nowrap">
                Unlike "likes" on other platforms, Twigs have real value.{' '}
              </p>
              <p>This changes how people engage with content.</p>
            </h2>
          </div>

          {/* Avatar / Illustration (bottom-aligned on larger screens) */}
          <div className="md:self-end flex justify-center md:justify-start">
            <img
              src={AvatarGraphic}
              alt="Person holding coin illustration"
              className="absolute top-28 right-0 md:static w-40 md:w-56 lg:w-60 drop-shadow-sm"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
